import { FleetManagementRow, FleetManagementRowValues } from "../types/FleetManagement-row.types";

/**
 * takes row data and assembles a partial fleet item object
 */
export function mapUpdatedRowToPartialFleetItem(
  values: FleetManagementRowValues,
  rowOriginal: FleetManagementRow
): Partial<FleetManagementRow> {
  return {
    id: values["id"] ?? rowOriginal.id,
    name: values.name,
    description: values["description"],
    picturePaths: values.picturePaths,
    licensePlate: values.licensePlate,
    brandModel: values.brandModel,
    vehicleType: values.vehicleType,
    fuel: values.fuel,
    reach: values.reach,
    numSeats: values.numSeats,
    pricePerHour: values.pricePerHour,
    bufferMinutes: values.bufferMinutes,
    properties: values.properties,
    status: values.status,
    odometer: values.odometer,
    adminNotes: values.adminNotes,
    userNotes: values.userNotes,
    contractDetails: values.contractDetails,
    attachments: values.attachments,
    location: {
      id: values["location.id"],
      name: values["location.name"]
    },
    companyId: values.companyId ?? rowOriginal.companyId ?? null,
    companyName: values.companyName ?? rowOriginal.companyName ?? null,
    fleetPermissions: values.fleetPermissions,
    occupiedBooking: values.occupiedBooking,
    blockedEvents: values.blockedEvents
  };
}
